import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { Observable } from "rxjs";

@Injectable()
export class AuthGuard implements CanActivate {

	constructor(private authService: AuthService, private router: Router) {}

	canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

		let isAuthenticated: any = this.authService.isAuthenticated();

		if (typeof(isAuthenticated) !== 'boolean') {
			return isAuthenticated
				.map(response => {
					if (response) {
						return true;
					}

					this.router.navigate(['/auth/login']);
					return false;
				});
		}

		this.router.navigate(['/auth/login']);
		return isAuthenticated;
			
	}
}


// WEBPACK FOOTER //
// ./src/app/shared/guards/auth.guard.ts